/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OfficialForEntry } from './OfficialForEntry';
import {
    OfficialForEntryFromJSON,
    OfficialForEntryFromJSONTyped,
    OfficialForEntryToJSON,
    OfficialForEntryToJSONTyped,
} from './OfficialForEntry';

/**
 * 
 * @export
 * @interface OfficialForResponse
 */
export interface OfficialForResponse {
    /**
     * 
     * @type {Array<OfficialForEntry>}
     * @memberof OfficialForResponse
     */
    entries: Array<OfficialForEntry>;
}

/**
 * Check if a given object implements the OfficialForResponse interface.
 */
export function instanceOfOfficialForResponse(value: object): value is OfficialForResponse {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function OfficialForResponseFromJSON(json: any): OfficialForResponse {
    return OfficialForResponseFromJSONTyped(json, false);
}

export function OfficialForResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfficialForResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(OfficialForEntryFromJSON)),
    };
}

export function OfficialForResponseToJSON(json: any): OfficialForResponse {
    return OfficialForResponseToJSONTyped(json, false);
}

export function OfficialForResponseToJSONTyped(value?: OfficialForResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entries': ((value['entries'] as Array<any>).map(OfficialForEntryToJSON)),
    };
}

